import { render } from "./promocionesdestacadas.vue?vue&type=template&id=53952938&scoped=true"
import script from "./promocionesdestacadas.vue?vue&type=script&lang=js"
export * from "./promocionesdestacadas.vue?vue&type=script&lang=js"

import "./promocionesdestacadas.vue?vue&type=style&index=0&id=53952938&scoped=true&lang=css"

import exportComponent from "C:\\HAZAKPUEBLA\\cedispage2.0jacve\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53952938"]])

export default __exports__